import { mediaMax } from '@/app/styles/breakpoints'
import { InvisibleButton } from '@/shared/ui/components/Button'
import { Flex } from 'antd'
import styled from 'styled-components'

export const AuthContainer = styled(Flex)`
  width: 100%;
  max-width: 932px;
  min-height: 589px;
  background-color: ${(props) => props.theme.colors.grayBackground};
  box-shadow: 8px 16px 64px 0px rgba(5, 117, 186, 0.25);
  border-radius: 6px;
  padding: 32px;
  position: relative;

  ${mediaMax.sm} {
    background: ${(props) => props.theme.colors.white};
    max-width: 100%;
    box-shadow: none;
    padding: 0;
    height: 100vh;
  }
`

export const FormContainer = styled(Flex)`
  max-width: 356px;
  width: 100%;
  .ant-form-item {
    margin-bottom: 0;
  }
`

export const FormInputs = styled(Flex)`
  gap: 24px;
`

export const FormWrapper = styled(Flex)`
  gap: 48px;
`

export const Logo = styled.img`
  width: auto;
  max-width: 100%;
  &.Omnicomm {
    height: 32px;
  }
  &.Axenta {
    height: 40px;
  }
  ${mediaMax.sm} {
    &.Omnicomm {
      height: 24px;
    }
  }
`

export const BackBtn = styled(InvisibleButton)`
  position: absolute;
  left: 24px;
  top: 26px;
  ${mediaMax.sm} {
    left: 16px;
    top: 28px;
  }
`
export const LoginHeader = styled(Flex)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 88px;
  box-shadow: 0px 4px 16px 0px rgba(12, 16, 24, 0.12);
  padding: 0 16px 0 64px;
`
